"use strict";
var _a, _b, _c, _d, _e;
Object.defineProperty(exports, "__esModule", { value: true });
exports.timelineTypeConfigs = exports.IUserTimelineType = exports.IUserTimelineStatus = void 0;
var IUserTimelineStatus;
(function (IUserTimelineStatus) {
    IUserTimelineStatus["SUCCEEDED"] = "SUCCEEDED";
    IUserTimelineStatus["ON"] = "ON";
    IUserTimelineStatus["OFF"] = "OFF";
})(IUserTimelineStatus = exports.IUserTimelineStatus || (exports.IUserTimelineStatus = {}));
var IUserTimelineType;
(function (IUserTimelineType) {
    IUserTimelineType["LOGIN_STATE"] = "LOGIN_STATE";
    IUserTimelineType["GPS_STATE"] = "GPS_STATE";
    IUserTimelineType["WORK_STATE"] = "WORK_STATE";
    IUserTimelineType["START_WORKDAY"] = "START_WORKDAY";
    IUserTimelineType["CLOSE_WORKDAY"] = "CLOSE_WORKDAY";
})(IUserTimelineType = exports.IUserTimelineType || (exports.IUserTimelineType = {}));
exports.timelineTypeConfigs = [
    {
        type: IUserTimelineType.LOGIN_STATE,
        title: 'Inlogstatus',
        status: (_a = {},
            _a[IUserTimelineStatus.ON] = {
                text: 'Gelogd',
                icon: 'login',
                titleClass: 'title-success'
            },
            _a[IUserTimelineStatus.OFF] = {
                text: 'Uitloggen',
                icon: 'logout',
                titleClass: 'title-danger'
            },
            _a)
    },
    {
        type: IUserTimelineType.GPS_STATE,
        title: 'GPS-status',
        status: (_b = {},
            _b[IUserTimelineStatus.ON] = {
                text: 'Toegestaan',
                icon: 'gps_fixed',
                titleClass: 'title-success'
            },
            _b[IUserTimelineStatus.OFF] = {
                text: 'Uitgeschakeld',
                icon: 'gps_off',
                titleClass: 'title-danger'
            },
            _b)
    },
    {
        type: IUserTimelineType.WORK_STATE,
        title: 'Ik werk vandaag',
        status: (_c = {},
            _c[IUserTimelineStatus.ON] = {
                text: 'Ingeschakeld',
                icon: 'gps_fixed',
                titleClass: 'title-success'
            },
            _c[IUserTimelineStatus.OFF] = {
                text: 'Uitgeschakeld',
                icon: 'gps_off',
                titleClass: 'title-danger'
            },
            _c)
    },
    {
        type: IUserTimelineType.START_WORKDAY,
        title: 'Begonnen werkdag',
        status: (_d = {},
            _d[IUserTimelineStatus.SUCCEEDED] = {
                text: 'Geslaagd',
                icon: '',
                titleClass: ''
            },
            _d)
    },
    {
        type: IUserTimelineType.CLOSE_WORKDAY,
        title: 'Gesloten werkdag',
        status: (_e = {},
            _e[IUserTimelineStatus.SUCCEEDED] = {
                text: 'Geslaagd',
                icon: '',
                titleClass: ''
            },
            _e)
    }
];
